import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/qr-codes")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$orgSlug/admin/promote/assets",
      params: { orgSlug: params.orgSlug },
    });
  },
});
